// File: client/src/variant/cardEffects/bonusMoves.js
//
// Effect kind: 'bonus_moves'
// Number cards / Draw Two / Draw Four. Grants the player a TOTAL of N legal moves
// this turn (so the directive adds N-1 bonus moves on top of the normal 1). When
// `noSamePieceTwice` is set, the turn controller forbids moving the same piece on
// consecutive moves (enforced via beforeMove using lastMovedPieceKey).
//
// The actual move application and the "checkmate ends immediately" rule are owned
// by the turn controller / chess engine (DESIGN PRINCIPLE #1); this effect only
// declares intent.

const bonusMoves = {
  kind: 'bonus_moves',

  onPlay: ({ card }) => {
    const params = (card && card.effect_json) || {};
    const total = typeof params.totalMoves === 'number' ? params.totalMoves : 1;
    const extra = Math.max(0, total - 1); // a normal turn already grants 1 move
    return {
      bonusMoves: extra,
      rule: { noSamePieceTwice: !!params.noSamePieceTwice },
      message:
        extra > 0
          ? `${card.name}: make ${total} moves this turn.`
          : `${card.name}: no extra moves.`,
    };
  },

  // Enforce "cannot move the same piece twice consecutively" when armed.
  beforeMove: ({ turnState, from, lastMovedPieceKey }) => {
    if (!turnState || !turnState.rules || !turnState.rules.noSamePieceTwice) {
      return undefined; // rule not active -> allow
    }
    // First move of the turn is always allowed.
    if (!lastMovedPieceKey) return { allow: true };
    const fromKey = Array.isArray(from) ? `${from[0]},${from[1]}` : String(from);
    if (fromKey === lastMovedPieceKey) {
      return { allow: false, reason: 'You cannot move the same piece twice in a row.' };
    }
    return { allow: true };
  },
};

export default bonusMoves;
